<div class="knowledge-hub-page">
  <app-header [forceLightBackground]="true"></app-header>

  <div class="knowledge-hub-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <div class="knowledge-hub-page--main">
      <div class="knowledge-hub-page--container">
        <section class="knowledge-hub-resources" aria-labelledby="resources-heading">
          <div class="knowledge-hub-resources--header">
            <div class="knowledge-hub-resources--header-row">
              <h2 id="resources-heading" class="knowledge-hub-resources--title">Resources</h2>
              <span class="knowledge-hub-resources--header-line" aria-hidden="true"></span>
            </div>
            <p class="knowledge-hub-resources--intro">Official documents and policy PDFs.</p>
          </div>
          <div class="knowledge-hub-resources--grid">
            <a
              *ngFor="let resource of resources"
              [href]="resource.url"
              target="_blank"
              rel="noopener noreferrer"
              class="knowledge-hub-resources--card"
              [attr.aria-label]="'Open Document: ' + resource.title"
            >
              <div class="knowledge-hub-resources--card-icon-wrap">
                <img
                  [src]="resource.imagePath"
                  [alt]=""
                  class="knowledge-hub-resources--card-image"
                  loading="lazy"
                />
              </div>
              <div class="knowledge-hub-resources--card-body">
                <h3 class="knowledge-hub-resources--card-title">{{ resource.title }}</h3>
                <p class="knowledge-hub-resources--card-desc">{{ resource.description }}</p>
                <span class="knowledge-hub-resources--card-cta">Open Document</span>
              </div>
            </a>
          </div>
        </section>
        <section class="knowledge-hub-stories" aria-labelledby="stories-heading">
          <div class="knowledge-hub-stories--header">
            <div class="knowledge-hub-stories--header-row">
              <h2 id="stories-heading" class="knowledge-hub-stories--title">Stories</h2>
              <span class="knowledge-hub-stories--header-line" aria-hidden="true"></span>
            </div>
            <p class="knowledge-hub-stories--intro">Data-driven narratives built from open datasets.</p>
          </div>
          <div class="knowledge-hub-stories--grid">
            <a
              *ngFor="let story of stories"
              [href]="story.storyUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="knowledge-hub-stories--card"
              [attr.aria-label]="'Open story: ' + story.title"
            >
              <div class="knowledge-hub-stories--card-image-wrap">
                <img
                  [src]="story.imagePath"
                  [alt]=""
                  class="knowledge-hub-stories--card-image"
                  loading="lazy"
                />
              </div>
              <div class="knowledge-hub-stories--card-body">
                <h3 class="knowledge-hub-stories--card-title">{{ story.title }}</h3>
                <p class="knowledge-hub-stories--card-desc">{{ story.description }}</p>
                <span class="knowledge-hub-stories--card-cta">View story</span>
              </div>
            </a>
          </div>
        </section>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
